import React from 'react';

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem, Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Table,
} from 'reactstrap';
import { useNavigate, useLocation } from "react-router-dom";

const CertificateInformation3 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const coursetrack = location.state ? location.state.courseTrack : "";
    const coursename = location.state ? location.state.courseName : "";
    const [open, setOpen] = React.useState(['7']); // Initialize open state with an empty array

    const toggle = (id) => {
        setOpen(prevOpen => {
            if (prevOpen.includes(id)) {
                // If the section is already open, remove it from the open state
                return prevOpen.filter(item => item !== id);
            } else {
                // If the section is not open, add it to the open state
                return [...prevOpen, id];
            }
        });
    };
    const handleEnrollClick = () => {

        navigate("/application-form", {
            state: {
                courseTrack: coursetrack,
                courseName: coursename,

            },
        });
    };

    return (

       



        <div className="container mt-1 p-3 mb-1" >


            <Row>
                <Col>
                    <h2 className=" text-center" style={{ color: '#123fae' }}
                    >
                        Certificate Course in Advanced Accounting

                        {/* <a href='a'
                            style={{ float: "right", fontSize: 15, color: "#e74c3c" }}
                            className="d-block mx-auto"
                            onClick={(event) => {
                                event.preventDefault(); // Prevents the default behavior (page reload)
                                handleEnrollClick(); // Calls your handleEnrollClick function
                            }}
                        >
                            Register Now
                        </a> */}

                    </h2>




                </Col>
            </Row>

            {/* <h4>Course Details:</h4> */}
            <Row>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card style={{ }}>
                        <CardHeader>
                            Course Details:
                        </CardHeader>




                        <ListGroup flush >

                            <ListGroupItem>
                                Language: English
                            </ListGroupItem>
                            <ListGroupItem>
                                Duration: 120 hours (3 months)
                            </ListGroupItem>
                            <ListGroupItem>
                                Learning Mode: Online
                            </ListGroupItem>
                            <ListGroupItem>
                                Certificate of Completion
                            </ListGroupItem>


                        </ListGroup>
                    </Card  ></Col>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card style={{ minHeight: "100%"}}>
                        <CardHeader >
                            Eligibility:
                        </CardHeader>




                        <ListGroup flush className="px-2">

                            <ListGroupItem>
                                <li> Learner should preferably be a 12th std. Pass student.</li>

                            </ListGroupItem>

                        </ListGroup>
                    </Card></Col>
            </Row>
            <br />
            <hr />
            <div >
                <h5 style={{ position: "relative" }}>
                    <span >
                        &#x1F449;
                    </span>
                    Why Certificate Course in Advanced Accounting
                </h5>
                <p>
                    Enroll in Advanced accounting and learn everything about Accounting!<br />   </p>
                <p>You will learn to make accurate and quick reports in no time! Become proficient in GST, voucher, currency, inventories and excise reports. The course also offers business management and data management skills.</p>


            </div>
            <hr />
            <h5 style={{ position: "relative" }}>

                What you'll learn ?
            </h5>
            <p>This course offers in-depth knowledge of Tally ERP9. You will get holistic learning experience. Covers various types of account transactions in diverse business and industries. With Tally ERP, you can maintain records of multiple companies. With the dynamic software, you can perform all accounting jobs including taxation, payroll accounting etc. You can go paperless with Tally ERP 9.</p>

            <hr />
            <div >
                <h5 style={{ left: "0" }}>Certification</h5>
                <ul><li> Advance Accounting course is jointly certified by CDOE, GJUST and HKCL.</li>
                </ul>
                <hr />
            </div>
            
           
            <div >
                <h5 style={{ left: "0" }}>Academic Approach</h5>
                <p>
                    The academic approach of the courses focuses on the “work-centric” education i.e. begin with work (and not from a book!), derive knowledge from work and apply that knowledge to make the work more wholesome, useful and delightful. The ultimate objective is to empower the Learner to engage in socially useful and productive work. It aims at leading the learner to his/her rewarding career as an employee or entrepreneur as well as development of the community to which s/he belongs.
                    Learning methodology:
                </p>



                <ul>
                    <li>Step -1: Learners are given an overview of the course and its connection to life and work.</li>
                    <li>Step -2: Learners are exposed to the specific tool(s) used in the course through the various real-life applications of the tool(s).</li>
                    <li>Step -3: Learners are acquainted with the careers and the hierarchy of roles they can perform at workplaces after attaining increasing levels of mastery over the tool(s).</li>
                    <li>Step -4: Learners are acquainted with the architecture of the tool or tool map so as to appreciate various parts of the tool, their functions, utility and inter-relations.</li>
                    <li>Step -5: Learners are exposed to simple application development methodology by using the tool at the beginner’s level.</li>
                    <li>Step -6: Learners perform the differential skills related to the use of the tool to improve the given ready-made industry-standard outputs.</li>
                    <li>Step -7: Learners are engaged in appreciation of real-life case studies developed by the experts.</li>
                    <li>Step -8: Learners are encouraged to proceed from appreciation to imitation of the experts.</li>
                    <li>Step -9: After the imitation experience, they are required to improve the expert’s outputs so that they proceed from mere imitation to emulation.</li>
                    <li>Step -10: Emulation is taken a level further from working with differential skills towards the visualization and creation of a complete output according to the requirements provided. (Long Assignments)</li>
                    <li>Step -11: Understanding the requirements, communicating one’s own thoughts and presenting are important skills required in facing an interview for securing a work order/job. For instilling these skills, learners are presented with various subject-specific technical as well as HR-oriented questions and encouraged to answer them.</li>
                    <li>Step -12: Finally, they develop the integral skills involving optimal methods and best practices to produce useful outputs right from scratch, publish them in their ePortfolio and thereby proceed from emulation to self-expression, from self-expression to self-confidence and from self-confidence to self-reliance and self-esteem!</li>
                </ul>
            </div>
            <hr />
            <div >

                <h5 style={{ left: "0" }}>Admission Guidelines</h5>
                <p>
                    
                    <ol>
                    <li>
            <b>Online Registration: </b> Learner needs to visit <a href="https://www.gjuskillcourses.hkcl.in">www.gjuskillcourses.hkcl.in</a> and make an online payment for admission confirmation. Kindly refer online admission process guidelines for more details.
          </li>
                        
                    </ol>
                </p>
            </div>
            <hr />

            <h5>Syllabus</h5>
            <p><b>Skills:</b> Creating Group, Entry of Registration Fees, Activation of Service Tax, Provision and Depreciation Entries, Pass the Transaction, Create Units of Measure, Activation of Interest Calculation, Activation of CST, Multiple level pricing, Interest Calculation, Simple Interest, Set up and Configuration</p>
            <p><b>Outputs: </b>Balance Sheet, Credit sales Entry, Create Sales Excise Voucher, Ledger Creation, Create Stock Go-down, Checking Order, Create Stock Item, Voucher Creation, Cost Centre Creation</p>
            <div className='p-4' >

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="7">Advanced Accounting</AccordionHeader>
                        <AccordionBody accordionId="7">
                            <ul>
                                <li>Cost centers and cost categories</li>
                                <li>Creating different ledgers</li>
                                <li>Creating different cost categories and Centres</li>
                                <li>Making different types of voucher entries</li>
                                <li>Viewing different cost center reports</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="8">Interest Calculations</AccordionHeader>
                        <AccordionBody accordionId="8">
                            <ul>
                                <li>Activating Interest Calculation</li>
                                <li> Interest on Outstanding Balances</li>
                                <li> Ledger Interest</li>
                                <li> Interest on Invoices, Interest Parameters</li>
                                <li> Debit Note Interest</li>
                                <li> Calculating Interest in Advanced Mode</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="9">Budgets and Controls</AccordionHeader>
                        <AccordionBody accordionId="9">
                            <ul>
                                <li> Budgets Introduction, Activation and Types</li>
                                <li>Closing Balance Budget</li>
                                <li>Ledger Budget Report</li>
                                <li>Cost Centre Budget & Report</li>
                                <li>Basic Knowledge of Standard Costing</li>
                                <li>Ratio Analysis, Cash Flow and Funds Flow</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="10">Job Costing</AccordionHeader>
                        <AccordionBody accordionId="10">
                            <ul>
                                <li> Features of Job Costing</li>
                                <li>Activation</li>
                                <li>Recording job costing related transaction</li>
                                <li>Reports</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="11">Job Work Order</AccordionHeader>
                        <AccordionBody accordionId="11">
                            <ul>
                                <li>Activation</li>
                                <li>Voucher Type setup for job work out/in</li>
                                <li>Job order processing</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="12">Advanced Payroll</AccordionHeader>
                        <AccordionBody accordionId="12">
                            <ul>
                                <li>Payroll & Statutory Details</li>
                                <li>Income Tax</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="13">GSTR 1,2,3B</AccordionHeader>
                        <AccordionBody accordionId="13">
                            <ul>
                                <li>Returns summary</li>
                                <li> Computation details</li>
                                <li>Summary of exceptions</li>
                                <li> Table wise GSTR 1, 2, 3B</li>
                                <li> Status reconciliation</li>
                                <li>HSN summary</li>
                                <li>Exporting GSTR 1, 2, 3B</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>


                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="14">Access Control & Security management</AccordionHeader>
                        <AccordionBody accordionId="14">
                            <ul>
                                <li> Enabling Security Control</li>
                                <li> Defining Security Level</li>
                                <li>Create Users</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="15">Data Synchronization</AccordionHeader>
                        <AccordionBody accordionId="15">
                            <ul>
                                <li>Reports, Types and Trial Balances</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="16">SMS</AccordionHeader>
                        <AccordionBody accordionId="16">
                            <ul>
                                <li>Introduction</li>
                                <li>Configuration</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="17">Control Centre</AccordionHeader>
                        <AccordionBody accordionId="17">
                            <ul>
                                <li> Control centre</li>
                                <li> Support centre</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

            </div>
            <hr />




        <div style={{ overflowX: 'auto' }}>
        <h5>Evaluation Pattern</h5>
        <Table bordered striped >
          <thead>
            <tr>
              <th>Section No.</th>
              <th>Section Name</th>
              <th>Total Marks</th>
              <th>Minimum Passing Marks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Learning Progression</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Internal Assessment</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Final Online Examination</td>
              <td>50</td>
              <td>20</td>
            </tr>
            <tr>
              <th colSpan="2" style={{ textAlign: "right" }}> Total</th>
              <th>100</th>
              <th>40</th>
            </tr>
            
          </tbody>
        </Table>
      </div>
      <hr />

      <div>
        <h5>Certificate of Completion</h5>
        <p>
          The certificate will be provided to the learner who will satisfy the below criteria:
        </p>
        
          <li>
            Learners who have successfully completed above mentioned 3 Sections i.e. Section 1, Section 2, and Section 3.
          </li>
          
        
      </div>
      <hr />
      <div>
        <h5>Fee Structure</h5>
        <p>Fee applicable from 2024 Batch onwards as mentioned below:</p>
        <Table bordered>
          <thead>
            <tr>
              <th>Mode</th>
              <th>Total Fee (Rupees)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Single Installment</td>
              <td>4500/-</td>
            </tr>
          </tbody>
        </Table>
        <p>Total fee is including of Course fees, Examination fees, and Certification fees.</p>
      </div>
     

      <li>
        <span style={{ color: 'red' }}>
         Additionally, the One Time Registration Fee is Rs. 100/-. </span>
      </li>
      


    </div >
  


    );
}
export default CertificateInformation3;